import DateRangePicker, {
  DateRangePreset,
  PRESET_OPTIONS,
} from '@components/common/DateRangePicker';
import Disclaimer from '@components/common/Disclaimer';
import { FilterItemContainer } from '@components/filter/FilterStyle';

interface Props {
  title: string;
  startDate: string;
  endDate: string;
  onChange: (event: { target: { name: string; value: string } }) => void;
  defaultPreset?: DateRangePreset;
  maxPeriod?: DateRangePreset;
  disabled?: boolean;
  description?: string;
}

const DateRangeFilter = ({
  title,
  startDate,
  endDate,
  onChange,
  defaultPreset,
  maxPeriod,
  disabled,
  description,
}: Props) => {
  const maxPeriodLabel = maxPeriod
    ? PRESET_OPTIONS.find((opt) => opt.value === maxPeriod)?.label
    : null;

  return (
    <FilterItemContainer>
      {title && <h3>{title}</h3>}
      {maxPeriodLabel && (
        <Disclaimer message={`최대 ${maxPeriodLabel}까지 조회할 수 있습니다.`} dense type="info" />
      )}
      {description && <Disclaimer message={description} dense type="info" />}
      <DateRangePicker
        startDate={startDate}
        endDate={endDate}
        onChange={onChange}
        defaultPreset={defaultPreset}
        maxPeriod={maxPeriod}
        disabled={disabled}
      />
    </FilterItemContainer>
  );
};

export default DateRangeFilter;
export { DateRangePreset };
